import React, { createContext, useState, ReactNode } from 'react';

interface LoadProps {
  isLoad: boolean;
  setIsLoad: React.Dispatch<React.SetStateAction<boolean>>;
  text: string;
  setText: React.Dispatch<React.SetStateAction<string>>;
}

const LoadContext = createContext<LoadProps>({
  isLoad: false,
  setIsLoad: () => {},
  text: '',
  setText: () => {},
});

interface ContextProps {
  children: ReactNode;
}

export function LoadProvider({ children }: ContextProps) {
  const [isLoad, setIsLoad] = useState(false);
  const [text, setText] = useState('');

  return (
    <LoadContext.Provider
      value={{
        isLoad,
        setIsLoad,
        setText,
        text,
      }}
    >
      {children}
    </LoadContext.Provider>
  );
}

export default LoadContext;
